/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOauthVerificationKeyInput = {
    clientId?: string | null | undefined;
    redirectUri?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createOauthVerificationKeyMutationVariables = {
    input: CreateOauthVerificationKeyInput;
};
export type createOauthVerificationKeyMutationResponse = {
    readonly createOauthVerificationKey: {
        readonly code: string | null;
    } | null;
};
export type createOauthVerificationKeyMutation = {
    readonly response: createOauthVerificationKeyMutationResponse;
    readonly variables: createOauthVerificationKeyMutationVariables;
};



/*
mutation createOauthVerificationKeyMutation(
  $input: CreateOauthVerificationKeyInput!
) {
  createOauthVerificationKey(input: $input) {
    code
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOauthVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOauthVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOauthVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createOauthVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOauthVerificationKeyMutation(\n  $input: CreateOauthVerificationKeyInput!\n) {\n  createOauthVerificationKey(input: $input) {\n    code\n  }\n}\n"
  }
};
})();
(node as any).hash = '389c735c26110d6465a7479ef7661bcf';
export default node;
